<div class="visualization-container" [style.border-color]="borderColor" [style.background-color]="backgroundColor">
  <div class="label-sm">{{ label }}</div>
  <div #grid *ngIf="instructions?.length" [ngStyle]="gridStyles$ | async">
    <app-investment-instructions-card *ngFor="let instruction of instructions" [instruction]="instruction" />
  </div>
</div>
